module.exports = __webpack_public_path__ + "static/media/case1.875ee719.png";